import type { AxiosHeaders, RawAxiosResponseHeaders } from 'axios';
import type { ICursorPaginationInfo, IPaginationInfo } from 'types/api-query.ts';

export interface WithPagination<T> {
  data: T;
  pagination: IPaginationInfo | null;
}

export interface IWithCursorPagination<T> {
  data: T;
  pagination: ICursorPaginationInfo | null;
}

export const preparePagination = (headers: AxiosHeaders | RawAxiosResponseHeaders): IPaginationInfo | null => {
  const _h = headers as AxiosHeaders;
  const currentPage = _h.get('x-pagination-current-page');
  const limit = _h.get('x-pagination-limit');
  const totalCount = _h.get('x-pagination-total-count');
  const pageCount = _h.get('x-pagination-page-count');

  if (!currentPage || !limit || !totalCount || !pageCount) return null;

  return {
    currentPage: Number(currentPage),
    limit: Number(limit),
    total: Number(totalCount),
    pageCount: Number(pageCount),
  };
};

export const prepareCursorPagination = (
  headers: AxiosHeaders | RawAxiosResponseHeaders,
): ICursorPaginationInfo | null => {
  const _h = headers as AxiosHeaders;
  const cursor = _h.get('x-pagination-cursor');
  const limit = _h.get('x-pagination-limit');
  const hasMore = _h.get('x-pagination-has-more');

  if (cursor === null || limit === null || hasMore === null) return null;

  return {
    cursor: String(cursor) || null,
    limit: Number(limit),
    hasMore: String(hasMore) === 'true',
  };
};
